export enum ComplaintStatusEnum {
  New = "New",
  Pending = "Pending",
  Closed = "Closed",
  Canceled = "Canceled",
}
